// components
import { Container } from 'components/Grid';

// styles
import {
  IntroductionTextWrapper,
  Title,
  Content,
} from './IntroductionText.styles';

export function IntroductionText() {
  return (
    <IntroductionTextWrapper>
      <Container>
        <Title>
          Lower freight costs and boost performance with Loadsmart’s software
          and services.
        </Title>
        <Content>
          Loadsmart is a logistics solutions provider automating how freight is
          priced, booked and shipped. Whether through digital brokerage, freight
          procurement tools, dock scheduling software, truck management
          software, managed transportation services, freight and network
          optimization or custom solutions, our shippers and carriers move more
          with less.
        </Content>
      </Container>
    </IntroductionTextWrapper>
  );
}
